import {
    getMiscSessionFetchReducer,
    postMiscSessionCreateReducer,
    staticDataReducer,
} from '../../slices/gq-svc-pp';

export const gqSvcPpMiscReducers = {
    getMiscSessionFetch: getMiscSessionFetchReducer,
    postMiscSessionCreate: postMiscSessionCreateReducer,
    staticData: staticDataReducer,
};